import keysGenerator, { plural } from '@/_CRUDL/generators/keys';

import actionsGenerator from '@/_CRUDL/generators/actions';
import mutationsGenerator from '@/_CRUDL/generators/mutations';
import stateGenerator from '@/_CRUDL/generators/state';
import constantsGenerator from '@/_CRUDL/generators/constants';
import endpointsGenerator from '@/_CRUDL/generators/endpoints';
import methodsGenerator from '@/_CRUDL/generators/methods';

export default function (key, options = {}) {
  const pluralized = plural(key);

  const keys = keysGenerator(key, options.customKeys);
  const endpoints = endpointsGenerator(pluralized, options.customEndpoints);
  const methods = methodsGenerator(options.customMethods);
  const constants = constantsGenerator(pluralized);

  const actions = actionsGenerator(endpoints, constants, methods);
  const mutations = mutationsGenerator(keys, constants);
  const state = stateGenerator();

  return {
    namespaced: true,
    state: {
      ...state,
    },
    actions: {
      ...actions,
    },
    mutations: {
      ...mutations,
    },
    _crudl: {
      constants,
      endpoints,
      keys,
      methods,
    },
  };
}
